<script setup lang="ts">
const carousels = [
  {
    title: 'Download Aplikasi KiriminAja',
    description: 'Di Google Play atau App Store'
  },
  {
    title: 'Login atau Daftar Akun Baru',
    description: 'Pakai Email atau Nomor HP'
  },
  {
    title: 'Mulai Kirim Paketmu',
    description: 'Pilih ekspedisi, buat resi dan lacak kiriman langsung dari HP'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container-highest py-6 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-6 lg:gap-11 relative z-10">
      <UiSectionTitle
        class="lg:text-center"
        title="Cara Lengkap 3 Langkah Mudah"
      />
      <UiCarouselFeature
        :items="carousels"
        hide-nav-button
        class-content-wrapper="overflow-visible"
      />
    </UiContainer>
  </div>
</template>
